const organisationInfo = {
  name: "CP Insurance Pty Ltd trading as Co-Pilot Insurance",
  afsl: "232987",
  abn: "24 679 312 460",
  address: "65 Kimberley Road Hurstville, NSW 2220",
  email: "apply@cpfi.com.au",
  tel: "1300 673 171",
};

export { organisationInfo };
